import { Box, Tabs } from '@hopskipdrive/react-components';
import { colorTokens, variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const RideTabs = styled(Tabs).attrs({ 'aria-label': 'Ride views', showIndicator: true })`
  /* HSD Tabs supplies the focus ring and indicator styles. */
`;

export const TabsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-top: 24px;

  svg {
    width: 20px;
  }

  .MuiTabs-root {
    min-width: 0;
  }

  ${variables.mediaQuery.lessThan('desktop')`
    background-color: ${colorTokens.background.light};    
    margin: 24px 0 0;   
  `}
`;
